module.exports = __webpack_public_path__ + "img/ms.199a5a6b.png";